module.exports = __webpack_public_path__ + "img/5110597.jpg";